import React from 'react';
import { ReactSwitchProps } from 'react-switch';

import { Container, Label, ToggleButton } from './styles';

interface IToggleProps extends ReactSwitchProps {
  label?: string;
  isDisabled?: boolean;
  altOffColor?: boolean;
}

const Toggle = React.forwardRef<HTMLInputElement, IToggleProps>(
  ({ label, isDisabled, altOffColor = false, ...rest }: IToggleProps) => {
    return (
      <Container>
        <Label>{label || 'Ativo?'}</Label>
        <ToggleButton
          disabled={isDisabled}
          offColor={altOffColor ? '#747474' : '#ff0000'}
          {...rest}
        />
      </Container>
    );
  },
);

export default Toggle;
